import CustomerGroupList from "./components/List"
import CustomerGroupForm from "./components/Form"
import CustomerGroupView from "./components/View"

let module = "customergroups"

export default [
  { path: "customergroups", component: CustomerGroupList, meta: { module: module, permissions: ["customergroup-access"] } },
  {
    path: "customergroups/create",
    component: CustomerGroupForm,
    props: true,
    meta: { module: module, permissions: ["customergroup-create"] }
  },
  {
    path: "customergroups/edit/:id",
    component: CustomerGroupForm,
    props: true,
    meta: { module: module, permissions: ["customergroup-edit"] }
  },
  {
    path: "customergroups/view/:id",
    component: CustomerGroupView,
    props: true,
    meta: { module: module, permissions: ["customergroup-access"] }
  }
]
